const state = () => ({
    basketInsurances   : [],
    itemInsurances     : {},
    selectedInsurances : [],
    blacklist          : [],
    ergoItemId         : null,
    ergoOrderProp      : null,
    blacklistCheck     : {},
    coreInitialized    : false
})

const mutations =
{
    setErgoBasketInsurances(state, basketInsurances)
    {
        state.basketInsurances = basketInsurances;
    },
    updateErgoBasketInsurance(state, {basketInsurance, quantity})
    {
        const ergoBasketInsurance = state.basketInsurances.find(ergoBasketInsurance => ergoBasketInsurance.id === basketInsurance.id);

        ergoBasketInsurance.quantity = quantity;
    },
    setItemInsurances(state, {variationId, itemInsurances})
    {
        Vue.set(state.itemInsurances, variationId, itemInsurances.insurances);
    },

    setSelectedInsurance(state, selectedInsurances)
    {
        state.selectedInsurances = selectedInsurances;
    },
    ergoSetItemId(state, id)
    {
        if(id !== state.ergoItemId && id !== null) {
            state.ergoItemId = id;
        }
    },
    setItemOrderProp(state, prop)
    {
        state.ergoOrderProp = prop.id;
    },
    setBlacklist(state, blacklist)
    {
        state.blacklist = blacklist;
    },
    setBlacklistCheck(state, value)
    {
        state.blacklistCheck[value.id] = value.value;
    },
    setCoreInitialized(state, value)
    {
        state.coreInitialized = value;
    }
}

const actions =
{
    loadItemInsurances({commit, state, getters}, variationId)
    {
        $.get('/ergo/ergo-insurances' + getters.getTrailingSlash + '?variationId='+variationId, function(itemInsurances) {
            commit("setItemInsurances", {variationId, itemInsurances});
            commit("setBlacklist", itemInsurances.blacklist);
            commit("setItemOrderProp", itemInsurances.property);
        });
    },
    loadBasketInsuranceData({commit, getters})
    {
        $.get('/ergo/ergo-basket' + getters.getTrailingSlash, function( basketInsurances ) {
            commit("setErgoBasketInsurances", JSON.parse(basketInsurances));
        });
    },
    setSelectedInsurance({commit, state, getters}, selectedInsurances)
    {
        commit("setSelectedInsurance", selectedInsurances);
    },

    addErgoBasketInsurance({commit, getters}, basketInsurance)
    {
        return new Promise((resolve, reject) =>
        {
            $.post('/ergo/ergo-basket' + getters.getTrailingSlash, basketInsurance).done(function (basketInsurances) {
                commit('setErgoBasketInsurances', JSON.parse(basketInsurances));
                resolve(JSON.parse(basketInsurances));
            }).fail(function(error) {
                reject(error);
            });
        });
    },
    removeErgoBasketInsurance({commit, getters}, basketInsurance)
    {
        return new Promise((resolve, reject) =>
        {
            $.ajax({
                url: "/ergo/ergo-basket" + getters.getTrailingSlash,
                method: "DELETE",
                data: basketInsurance
            }).done(function (basketInsurances) {
                commit("setErgoBasketInsurances", JSON.parse(basketInsurances));
                resolve(JSON.parse(basketInsurances));
            }).fail(function(error) {
                reject(error);
            });
        });
    },
}

const getters =
{
    getTrailingSlash()
    {
        if(
            typeof App !== 'undefined' &&
            typeof App.urlTrailingSlash !== 'undefined' &&
            App.urlTrailingSlash === true
        ) {
            return '/';
        }

        return '';
    }
}

export default {
    state,
    mutations,
    actions,
    getters
}
